import { Client } from './client.models';
import { Voucher } from './voucher.models';

export enum ReturnStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PROCESSED = 'PROCESSED'
}

export enum ReturnReason {
  DEFECTIVE = 'DEFECTIVE',
  WRONG_ITEM = 'WRONG_ITEM',
  NOT_AS_DESCRIBED = 'NOT_AS_DESCRIBED',
  CUSTOMER_CHANGED_MIND = 'CUSTOMER_CHANGED_MIND',
  DAMAGED_IN_SHIPPING = 'DAMAGED_IN_SHIPPING',
  OTHER = 'OTHER'
}

export class Return {
  id: number;
  returnNumber: string;           // RET-YYYYMMDD-####
  originalVoucherId?: number;     // Comprobante original
  clientId: number;               // Cliente
  status: ReturnStatus;           // Estado actual
  reason: ReturnReason;           // Motivo
  description?: string;           // Descripción
  internalNotes?: string;         // Notas internas
  totalAmount?: number;           // Monto total
  requestedAt: Date;              // Fecha solicitud
  approvedAt?: Date;              // Fecha aprobación
  processedAt?: Date;             // Fecha procesamiento
  approvedBy?: string;            // Quien aprobó
  processedBy?: string;           // Quien procesó
  createdBy: string;              // Quien creó
  metadata?: object;              // Metadatos adicionales
  createdAt: Date;
  updatedAt: Date;
  
  // Relaciones
  originalVoucher?: Voucher;
  client: Client;
  details: ReturnDetail[];
}

export class ReturnDetail {
  id: number;
  returnId: number;
  variantId: number;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
  productName?: string;
  variantName?: string;
}

export interface ReturnPolicy {
  returnPeriodDays: number;
  returnableReasons: ReturnReason[];
  requiresApproval: boolean;
  autoProcessRefunds: boolean;
}

export interface CreateReturnRequest {
  originalVoucherId?: number;
  clientId: number;
  reason: ReturnReason;
  description?: string;
  details: CreateReturnDetailRequest[];
}

export interface CreateReturnDetailRequest {
  variantId: number;
  quantity: number;
  unitPrice: number;
}

export interface UpdateReturnRequest {
  reason?: ReturnReason;
  description?: string;
  internalNotes?: string;
  details?: CreateReturnDetailRequest[];
}

export interface ReturnFilters {
  page?: number;
  limit?: number;
  status?: ReturnStatus;
  clientId?: number;
  dateFrom?: string;
  dateTo?: string;
  returnNumber?: string;
  originalVoucherNumber?: string;
}